module.exports = __webpack_public_path__ + "static/media/call-report-save-icon.3ed16095.svg";